// extracted by mini-css-extract-plugin
export default {"share-certificate-button":"ShareCertificateButton_share-certificate-button__xCMB3"};